import { useCallback, useEffect, useState } from 'react';
import { aiService } from '../../services/api';

/** Situação da IA para a pessoa (pronta, sem configuração, limite do dia, via chave própria). */
export function useAIStatus(enabled = true) {
  const [status, setStatus] = useState(null);
  const refresh = useCallback(() => {
    if (!enabled) return;
    aiService.status().then(setStatus).catch(() => setStatus({ state: 'ERROR', available: false }));
  }, [enabled]);
  useEffect(() => { refresh(); }, [refresh]);
  return [status, refresh, setStatus];
}
